export default [
  {
    id: 'checkout-billing-data-company-name',
    name: 'company',
    label: 'smb_acquisition_company_info.fields.company_name.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 8,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-tax-id',
    name: 'taxId',
    label: 'smb_acquisition_company_info.fields.tax_id.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 4,
    },
    validations: {
      primitiveType: 'number',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-zip',
    name: 'zip',
    label: 'smb_acquisition_company_info.fields.address.zip_code.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 4,
    },
    options: {
      mask: '99999',
    },
    validations: {
      primitiveType: 'string',
      required: true,
      min: 5,
    },
  },
  {
    id: 'checkout-billing-data-street-address',
    name: 'streetAddress',
    label:
      'smb_acquisition_company_info.fields.address.address_line_1.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 8,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-complement',
    name: 'complement',
    label:
      'smb_acquisition_company_info.fields.address.address_line_2.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 8,
    },
    validations: {
      primitiveType: 'string',
      required: false,
    },
  },
  {
    id: 'checkout-billing-data-street-number',
    name: 'streetNumber',
    label:
      'smb_acquisition_company_info.fields.address.street_number.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 4,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-state',
    name: 'state',
    label: 'smb_acquisition_company_info.fields.address.state.placeholder',
    componentType: 'select',
    columnSize: {
      small: 12,
      medium: 6,
    },
    items: {
      translation: false,
      defaultElements: {
        insertionMode: 'before', // after, mergeAndSort, clean
        elements: [
          {
            value: '',
            name: '',
          },
          {
            value: 'Alabama',
            name: 'Alabama',
          },
          {
            value: 'Alaska',
            name: 'Alaska',
          },
          {
            value: 'American Samoa',
            name: 'American Samoa',
          },
          {
            value: 'Arizona',
            name: 'Arizona',
          },
          {
            value: 'Arkansas',
            name: 'Arkansas',
          },
          {
            value: 'California',
            name: 'California',
          },
          {
            value: 'Colorado',
            name: 'Colorado',
          },
          {
            value: 'Connecticut',
            name: 'Connecticut',
          },
          {
            value: 'Delaware',
            name: 'Delaware',
          },
          {
            value: 'District Of Columbia',
            name: 'District Of Columbia',
          },
          {
            value: 'Federated States Of Micronesia',
            name: 'Federated States Of Micronesia',
          },
          {
            value: 'Florida',
            name: 'Florida',
          },
          {
            value: 'Georgia',
            name: 'Georgia',
          },
          {
            value: 'Guam',
            name: 'Guam',
          },
          {
            value: 'Hawaii',
            name: 'Hawaii',
          },
          {
            value: 'Idaho',
            name: 'Idaho',
          },
          {
            value: 'Illinois',
            name: 'Illinois',
          },
          {
            value: 'Indiana',
            name: 'Indiana',
          },
          {
            value: 'Iowa',
            name: 'Iowa',
          },
          {
            value: 'Kansas',
            name: 'Kansas',
          },
          {
            value: 'Kentucky',
            name: 'Kentucky',
          },
          {
            value: 'Louisiana',
            name: 'Louisiana',
          },
          {
            value: 'Maine',
            name: 'Maine',
          },
          {
            value: 'Marshall Islands',
            name: 'Marshall Islands',
          },
          {
            value: 'Maryland',
            name: 'Maryland',
          },
          {
            value: 'Massachusetts',
            name: 'Massachusetts',
          },
          {
            value: 'Michigan',
            name: 'Michigan',
          },
          {
            value: 'Minnesota',
            name: 'Minnesota',
          },
          {
            value: 'Mississippi',
            name: 'Mississippi',
          },
          {
            value: 'Missouri',
            name: 'Missouri',
          },
          {
            value: 'Montana',
            name: 'Montana',
          },
          {
            value: 'Nebraska',
            name: 'Nebraska',
          },
          {
            value: 'Nevada',
            name: 'Nevada',
          },
          {
            value: 'New Hampshire',
            name: 'New Hampshire',
          },
          {
            value: 'New Jersey',
            name: 'New Jersey',
          },
          {
            value: 'New Mexico',
            name: 'New Mexico',
          },
          {
            value: 'New York',
            name: 'New York',
          },
          {
            value: 'North Carolina',
            name: 'North Carolina',
          },
          {
            value: 'North Dakota',
            name: 'North Dakota',
          },
          {
            value: 'Northern Mariana Islands',
            name: 'Northern Mariana Islands',
          },
          {
            value: 'Ohio',
            name: 'Ohio',
          },
          {
            value: 'Oklahoma',
            name: 'Oklahoma',
          },
          {
            value: 'Oregon',
            name: 'Oregon',
          },
          {
            value: 'Palau',
            name: 'Palau',
          },
          {
            value: 'Pennsylvania',
            name: 'Pennsylvania',
          },
          {
            value: 'Puerto Rico',
            name: 'Puerto Rico',
          },
          {
            value: 'Rhode Island',
            name: 'Rhode Island',
          },
          {
            value: 'South Carolina',
            name: 'South Carolina',
          },
          {
            value: 'South Dakota',
            name: 'South Dakota',
          },
          {
            value: 'Tennessee',
            name: 'Tennessee',
          },
          {
            value: 'Texas',
            name: 'Texas',
          },
          {
            value: 'Utah',
            name: 'Utah',
          },
          {
            value: 'Vermont',
            name: 'Vermont',
          },
          {
            value: 'Virgin Islands',
            name: 'Virgin Islands',
          },
          {
            value: 'Virginia',
            name: 'Virginia',
          },
          {
            value: 'Washington',
            name: 'Washington',
          },
          {
            value: 'West Virginia',
            name: 'West Virginia',
          },
          {
            value: 'Wisconsin',
            name: 'Wisconsin',
          },
          {
            value: 'Wyoming',
            name: 'Wyoming',
          },
        ],
      },
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-city',
    name: 'city',
    label: 'smb_acquisition_company_info.fields.address.city.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-industry',
    name: 'industry',
    label: 'smb_acquisition_form.fields.industry.placeholder',
    componentType: 'select',
    columnSize: {
      small: 12,
      medium: 6,
    },

    items: {
      translation: true,
      defaultElements: {
        insertionMode: 'before', // after, mergeAndSort, clean
        elements: [
          { value: '', name: '' },
          {
            value: 'Agribusiness',
            intlKey:
              'smb_acquisition_form.fields.industry.options.agribusiness',
            name: 'Agribusiness',
          },
          {
            value: 'Airlines',
            intlKey: 'smb_acquisition_form.fields.industry.options.airlines',
            name: 'Airlines',
          },
          {
            value: 'Association',
            intlKey: 'smb_acquisition_form.fields.industry.options.association',
            name: 'Association',
          },
          {
            value: 'Construction',
            intlKey:
              'smb_acquisition_form.fields.industry.options.construction',
            name: 'Construction',
          },
          {
            value: 'Consultancy',
            intlKey: 'smb_acquisition_form.fields.industry.options.consultancy',
            name: 'Consultancy',
          },
          {
            value: 'Consumer Goods',
            intlKey:
              'smb_acquisition_form.fields.industry.options.consumer_goods',
            name: 'Consumer Goods',
          },
          {
            value: 'Education',
            intlKey: 'smb_acquisition_form.fields.industry.options.education',
            name: 'Education',
          },
          {
            value: 'Financial Services',
            intlKey:
              'smb_acquisition_form.fields.industry.options.financial_services',
            name: 'Financial Services',
          },
          {
            value: 'Food and Beverage',
            intlKey:
              'smb_acquisition_form.fields.industry.options.food_and_beverage',
            name: 'Food and Beverage',
          },
          {
            value: 'Government or Public Management',
            intlKey:
              'smb_acquisition_form.fields.industry.options.government_or_public_management',
            name: 'Government or Public Management',
          },
          {
            value: 'Health',
            intlKey: 'smb_acquisition_form.fields.industry.options.health',
            name: 'Health',
          },
          {
            value: 'HR, Staffing and Recruiting',
            intlKey:
              'smb_acquisition_form.fields.industry.options.hr_staffing_and_recruiting',
            name: 'HR, Staffing and Recruiting',
          },
          {
            value: 'Law Firms and Services',
            intlKey:
              'smb_acquisition_form.fields.industry.options.law_firms_and_services',
            name: 'Law Firms and Services',
          },
          {
            value: 'Leisure, Travel and Tourism',
            intlKey:
              'smb_acquisition_form.fields.industry.options.leisure_travel_and_tourism',
            name: 'Leisure, Travel and Tourism',
          },
          {
            value: 'Logistics and Supply Chain',
            intlKey:
              'smb_acquisition_form.fields.industry.options.logistics_and_supply_chain',
            name: 'Logistics and Supply Chain',
          },
          {
            value: 'Manufacturing and Production',
            intlKey:
              'smb_acquisition_form.fields.industry.options.manufacturing_and_production',
            name: 'Manufacturing and Production',
          },
          {
            value: 'Media, Marketing and Advertising',
            intlKey:
              'smb_acquisition_form.fields.industry.options.media_marketing_and_advertising',
            name: 'Media, Marketing and Advertising',
          },
          {
            value: 'Miscellaneous',
            intlKey:
              'smb_acquisition_form.fields.industry.options.miscellaneous',
            name: 'Miscellaneous',
          },
          {
            value: 'NGO/Charity',
            intlKey: 'smb_acquisition_form.fields.industry.options.ngo_charity',
            name: 'NGO/Charity',
          },
          {
            value: 'Pharma',
            intlKey: 'smb_acquisition_form.fields.industry.options.pharma',
            name: 'Pharma',
          },
          {
            value: 'Professional Services',
            intlKey:
              'smb_acquisition_form.fields.industry.options.professional_services',
            name: 'Professional Services',
          },
          {
            value: 'Retail and Wholesale',
            intlKey:
              'smb_acquisition_form.fields.industry.options.retail_and_wholesale',
            name: 'Retail and Wholesale',
          },
          {
            value: 'Self-management',
            intlKey:
              'smb_acquisition_form.fields.industry.options.self_management',
            name: 'Self-management',
          },
          {
            value: 'Technology',
            intlKey: 'smb_acquisition_form.fields.industry.options.technology',
            name: 'Technology',
          },
          {
            value: 'Telecom',
            intlKey: 'smb_acquisition_form.fields.industry.options.telecom',
            name: 'Telecom',
          },
          {
            value: 'Utilities, Energy, and Chemical',
            intlKey:
              'smb_acquisition_form.fields.industry.options.utilities_energy_and_chemical',
            name: 'Utilities, Energy, and Chemical',
          },
        ],
      },
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-company-phone',
    name: 'companyPhone',
    label: 'smb_acquisition_company_info.fields.phone.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    options: {
      mask: '(999) 999-9999',
    },
    validations: {
      primitiveType: 'string',
      required: true,
      phone: true,
      min: 10,
    },
  },
]
